/**
 * Describe 神策SDK
 * Document https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_use-7545024.html#id-%E9%9B%86%E6%88%90%E6%96%87%E6%A1%A3%EF%BC%88Web%EF%BC%89-%E8%AE%BE%E7%BD%AE%E4%BA%8B%E4%BB%B6%E5%85%AC%E5%85%B1%E5%B1%9E%E6%80%A7
 */

// 设备类型获取
import deviceType from '../../../utils/deviceType'
// 版本信息
// import manifestInfo from '@root/public/manifest.json'
import Vue from "vue";// 地址处理
// url处理
import $path from '../../../utils/path';
// 用户存储
import userStore from '../../../store/index'
// 门店处理
// import { targetStoreInfo as $targetStoreInfo } from "@comm/store/store.model";
// 本地应用版本信息
// const appVersionInfo = manifestInfo.appVersionInfo || {};
// 当前最新版本信息
// const newVersionInfo = (isEnvPro ? appVersionInfo.pro : (appVersionInfo.uat || appVersionInfo.dev)) || {};

// 是否启用神策
const isUse = true //env !== 'dev';
// 是否生产环境
// 该项目因为打包命令未区分测试和生产，因此先根据URL判断当前是否是测试环境；
console.log('process.env.NODE_ENV:', process.env.NODE_ENV)
let hostURL = window.location.host;
console.log('hostURL:', hostURL);
const isEnvPro = hostURL.includes("luckydraw.dominos.com.cn") ? process.env.NODE_ENV === "production" : false;

/******************************************* 封装的神策SDK公共方法 ******************************************/
// 实际埋点对象
let $Sensors;

// 埋点任务队列
let taskQueue = [];

/**
 * 神策埋点执行
 * @param fn
 * @returns {Promise<unknown>}
 */
function runSensors (fn) {

  return new Promise((resolve, reject) => {
    if (!isUse) return reject('神策sdk已设置"关闭启用"');
    // 避免抢占应用主要cpu/网络资源
    requestIdleCallback(function () {
      return typeof fn === "function" ? resolve($Sensors || import('./sensors.es6.js').then(({ default: sensors }) => $Sensors = sensors)) : reject("fn not function")
    }, { timeout: 5000 });
  }).then(sensors => fn(sensors))
}

/**
 * 神策处理命令代理
 * @param method
 * @param option
 * @returns {Promise<unknown>}
 */
function handleCmdProxy (method, option) {
  return new Promise((resolve, reject) => {
    if (!isUse) return reject('神策sdk已设置"关闭启用"');
    // 避免抢占应用主要cpu/网络资源
    requestIdleCallback(function () {
      if ($Sensors) {
        // 检查方法是否存在
        if (typeof $Sensors[method] === "function") {
          resolve(typeof option === "object" && option.multiple && option.options ? $Sensors[method](...option.options) : $Sensors[method](option));
        } else {
          reject(`神策sdk不支持:${method} 方法`)
        }
      } else {
        taskQueue.push({
          resolve, reject, method, option
        })
      }
    })
  })
}

/**
 * 神策sdk 初始化
 */
// export function init () {
//   runSensors(function (sensors) {
//     sensors.init({
//       server_url: 'https://userbehavior.dominos.com.cn/sa?project=' + (isEnvPro ? 'production' : 'default'),
//       // is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
//       show_log: false, // 埋点事件触发日志
//       use_client_time: true,
//       send_type: 'beacon',
//       heatmap: {
//         //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
//         clickmap: 'not_collect',
//         //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
//         scroll_notice_map: 'not_collect'
//       }
//     });
//     sensors.quick('autoTrack');
//     // 设置应用相关公共参数
//     setAppCommAttribute();
//     // 执行任务队列中的任务
//     while (taskQueue.length) {
//       // 读取到
//       let { resolve, reject, method, option } = taskQueue.shift();
//       // 避免抢占应用主要cpu/网络资源
//       requestIdleCallback(function () {
//         // 检查方法是否存在
//         if (typeof $Sensors[method] === "function") {
//           // 检查是否多个参数并执行
//           resolve(typeof option === "object" && option.multiple && option.options ? $Sensors[method](...option.options) : $Sensors[method](option));
//         } else {
//           reject(`神策sdk不支持:${method} 方法`)
//         }
//       })
//     }



//     // 用户关联埋点
//     loginTrack()

//     return sensors
//   }).catch(err => {
//     console.error(err)
//   })
// }

export function init () {
  runSensors(function (sensors) {
    // 设置应用相关公共参数
    setAppCommAttribute().finally(() => {
      sensors.init({
        server_url: 'https://userbehavior.dominos.com.cn/sa?project=' + (isEnvPro ? 'dominosproduction' : 'dominostest'),
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: 'beacon',
        heatmap: {
          //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          clickmap: 'not_collect', //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
          scroll_notice_map: 'not_collect'
        }
      });
      sensors.quick('autoTrack');

      // 执行任务队列中的任务
      while (taskQueue.length) {
        // 读取到
        let { resolve, reject, method, option } = taskQueue.shift();
        // 避免抢占应用主要cpu/网络资源
        requestIdleCallback(function () {
          // 检查方法是否存在
          if (typeof $Sensors[method] === "function") {
            // 检查是否多个参数并执行
            resolve(typeof option === "object" && option.multiple && option.options ? $Sensors[method](...option.options) : $Sensors[method](option));
          } else {
            reject(`神策sdk不支持:${method} 方法`)
          }
        }, { timeout: 1500 })
      }
      // 用户关联埋点
      loginTrack()
    });

    return sensors
  }).catch(err => {
    console.error(err)
  })
}
/**
 * 设置事件公共属性
 * @param option
 */
export function setCommAttribute (option) {
  return handleCmdProxy('registerPage', option).then(res => {

  }).catch(err => {
    console.error(err)
  });
}

/**
 * 设置用户属性
 * @param option
 */
export function setProfile (option) {
  handleCmdProxy('setProfile', option).catch(err => {
    console.error(err)
  });
}

/**
 * 属性添加
 * @param options
 */
export function addAttribute (...options) {
  handleCmdProxy('quick', {
    options, // 多参数埋点
    multiple: true
  }).catch(err => {
    console.error(err)
  });
}

/**
 * 神策埋点
 * @param options
 */
export function track (...options) {
  handleCmdProxy('track', {
    options: options.length === 1 ? options.concat({}) : options, // 多参数埋点
    multiple: true
  }).catch(err => {
    console.error(err)
  });
}

/******************************************* 应用业务相关的埋点/封装好的业务私有方法 ******************************************/

/**
 * 设置应用相关公共参数
 */
function setAppCommAttribute () {
  // 设备类型
  const { name: channelName } = deviceType();

  return setCommAttribute({
    // 小程序，WECHAT，IOS，ANDROID，WAP，SDS，web，ALI
    // sensors.registerApp() 接口注册；可以多次调用，会覆盖上次上传的公共属性；后端需要通过前端获取传到后端，再使用公共属性接口注册上传
    platform_name: channelName, // 设备平台 Mobile、PC
    device_platform: 'Mobile', // 版本号
    // app_version: newVersionInfo.version + '.' + newVersionInfo.innerVersion, // Member（注册会员）;Guest（手机号登录）;AuthorizedUser（未授权手机号，授权平台信息），Visitor（未授权手机号，未授权微信信息）
    // （如有，取值按现有值列举）
    status: function () {

      if (userStore.getters.getInfo) {
        // 用户信息获取
        const { loyalty, anonymousFlag } = userStore.getters.getInfo;
        if (loyalty) return "Member";
        if (anonymousFlag === 0) return "Guest";
        return "AuthorizedUser";
      }
      return "Visitor";
    }, // 会员等级
    member_level: function () {
      // 用户信息获取
      return userStore.getters.getInfo.loyalty;
    }, // 页面路径
    page_path () {
      return $path.normalize(window.location.origin + '/' + Vue.$nowPath.path)
    }, // 页面路径
    page_name () {
      return Vue.$nowPath.meta ? Vue.$nowPath.meta._$aliasTitle$_ || Vue.$nowPath.meta._$title$_ : '';
    }, //前向页面路径
    refer_page_path () {
      return Vue.$fromPath.path === Vue.$nowPath.path ? document.referrer : $path.normalize(window.location.origin + '/' + Vue.$fromPath.path)
    }, //前向页面名称
    refer_page_name () {
      return Vue.$fromPath.meta ? Vue.$fromPath.meta._$aliasTitle$_ || Vue.$fromPath.meta._$title$_ : '';
    },
  })
}

/**
 * 登录埋点
 */
function loginTrack () {
  // 登录埋点
  // userStore.getters.GetUserInfo.id && handleCmdProxy('login', userStore.getters.GetUserInfo.id).catch(err => {
  //   console.error(err)
  // });
  if (userStore.getters.getInfo && userStore.getters.getInfo.userId) {
    handleCmdProxy('login', userStore.getters.getInfo.userId).catch(err => {
        console.error(err)
    });

    // handleCmdProxy('bind', {
    //   options: ["identity_asuser_id", userStore.getters.getInfo.userId], // 多参数埋点
    //   multiple: true
    // }).catch(err => {
    //   console.error(err)
    // });
  }
}

// /**
//  * 神策商品操作埋点
//  * @param productInfo
//  * @param origin
//  * @param typeName
//  * @param scene
//  */
// function productAction (productInfo, origin, typeName, scene) {
//   // 目标门店
//   const targetStoreInfo = $targetStoreInfo() || {};
//   // 神策埋点
//   track(productInfo.productType === 2 ? "AddComboDetail" : "AddDetail", {
//     add_type: origin, // 操作类型 加入购物车，结算加购
//     click_type: typeName, // 点击类型 新增，删减
//     situation: scene, // 加购场景
//     original_price: productInfo.originalPrice, // 商品原价
//     currunt_price: productInfo.unitPrice, // 商品现价
//     store_id: targetStoreInfo.storeCode, // 门店id
//     store_name: targetStoreInfo.storeName, // 门店名称
//     classification: '', // 菜单分类名称
//     sub_classification: '', // 菜单子分类名称
//     sequence: '', // 排序
//     category: '', // 商品分类
//   });
// }

export default function (Vue) {
  // 注入插件
  Vue.$Sensors = Vue.prototype.$Sensors = {
    init, track, setProfile, loginTrack, addAttribute, setCommAttribute,

  };
}